import React, { useCallback, useState } from 'react';
import { Box, Typography, TextField, Button, Container } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import styled from 'styled-components';

const UploadWrapper = styled(Box)`
  border: 2px dashed #1976d2;
  padding: 20px;
  text-align: center;
  border-radius: 8px;
  background-color: #f9f9f9;
  cursor: pointer;
  margin-bottom: 20px;

  &:hover {
    background-color: #f0f8ff;
  }
`;

const PreviewImage = styled('img')`
  max-width: 100px;
  margin: 10px;
  border-radius: 4px;
`;

const FileUploadSection = () => {
  const [images, setImages] = useState([]);
  const [documents, setDocuments] = useState([]);

  // === IMAGE DROP HANDLER ===
  const onDropImages = useCallback((acceptedFiles) => {
    if (acceptedFiles.length + images.length > 10) {
      alert("You can upload a maximum of 10 images.");
      return;
    }

    setImages((prev) => [
      ...prev,
      ...acceptedFiles.map((file) => Object.assign(file, { preview: URL.createObjectURL(file) }))
    ]);
  }, [images]);

  // === DOCUMENT DROP HANDLER ===
  const onDropDocuments = useCallback((acceptedFiles) => {
    setDocuments((prev) => [
      ...prev,
      ...acceptedFiles.map((file) => ({ file, name: '', id: Date.now() + Math.random() }))
    ]);
  }, []);

  const handleDocNameChange = (id, value) => {
    setDocuments((prev) =>
      prev.map((doc) =>
        doc.id === id ? { ...doc, name: value } : doc
      )
    );
  };

  const { getRootProps: getImageRootProps, getInputProps: getImageInputProps } = useDropzone({
    onDrop: onDropImages,
    accept: { 'image/*': [] },
    multiple: true
  });

  const { getRootProps: getDocRootProps, getInputProps: getDocInputProps } = useDropzone({
    onDrop: onDropDocuments,
    multiple: true
  });

  return (
    <Container>
      <Box className="file-input">
        <Typography variant="h6">Upload Product Images (max 10):</Typography>
        <UploadWrapper {...getImageRootProps()}>
          <input {...getImageInputProps()} />
          <Typography>Drag & drop images here, or click to select</Typography>
        </UploadWrapper>
        <Box display="flex" flexWrap="wrap">
          {images.map((file, index) => (
            <PreviewImage key={index} src={file.preview} alt={`preview-${index}`} />
          ))}
        </Box>
      </Box>

      <Box className="file-input" mt={4}>
        <Typography variant="h6">Upload Supporting Documents:</Typography>
        <UploadWrapper {...getDocRootProps()}>
          <input {...getDocInputProps()} />
          <Typography>Drag & drop files here, or click to select</Typography>
        </UploadWrapper>

        {documents.map((doc, index) => (
          <Box key={doc.id} mt={2} display="flex" alignItems="center" gap={2}>
            <Typography>{doc.file.name}</Typography>
            <TextField
              label="Document Description"
              size="small"
              value={doc.name}
              onChange={(e) => handleDocNameChange(doc.id, e.target.value)}
            />
          </Box>
        ))}
      </Box>

      <Button variant="contained" color="primary" sx={{ mt: 4 }}>
        Submit Files
      </Button>
    </Container>
  );
};

export default FileUploadSection;
